import type { ReferenceGraphemeMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import { useMorphemeInfoPanelCompositionCompoundsSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.composition.__views.compounds";

/** This tab's sections as descriptors; see the dictionary equivalent for why it lives here. */
export function useMorphemeInfoPanelCompositionGraphemeSections({
  graphemeCard,
}: {
  graphemeCard: ReferenceGraphemeMorphemeSlice;
}): ReturnType<typeof useMorphemeInfoPanelCompositionCompoundsSection>[] {
  return [useMorphemeInfoPanelCompositionCompoundsSection({ graphemeCard })];
}
